import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findSafetyBlacklistPage = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyBlacklist?` + params,
    method: 'GET'
  });
};

export const addSafetyBlacklist = (data) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyBlacklist`,
    method: 'POST',
    data
  });

export const editSafetyBlacklist = (data) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyBlacklist`,
    method: 'PUT',
    data
  });

export const delSafetyBlacklist = (ids) =>
  request({
    url: `${baseUrl}/joins-sales-cloud/v1/safetyBlacklist/${ids}`,
    method: 'DELETE'
  });